import config from '@airasia-common/libraries/config';
import { get, post, remove } from '@airasia-common/libraries/http';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import genericApiSaga from '../genericApiSaga';
import { actionCreators, types } from '../../redux/favourites/favourites.meta';
import { getFavouriteHeader } from '../../helpers';
import { HOTELS_LOB_FAVOURITES } from '../../constants';
export function* itemFavourited({ payload }) {
  const {
    userId,
    lineOfBusinessItemId,
    data,
    accessToken,
    refreshToken,
  } = payload;
  const headers = yield getFavouriteHeader(accessToken, refreshToken);
  const weblink = `${config.REACT_APP_HOTEL_HOME_URL}/${lineOfBusinessItemId}`;
  let response;
  try {
    response = yield call(post, `/v1/users/${userId}/favouritedItems`, {
      baseUrl: config.REACT_APP_STATIC_FAVOURITE_BASE_URL,
      params: {
        lineOfBusinessItemId,
        lineOfBusiness: HOTELS_LOB_FAVOURITES,
        webLink: weblink,
        mobileLink: weblink,
        data: {
          ...data,
        },
      },
      headers: {
        ...headers,
      },
    });
    if (response.status === 201 || response.status === 200) {
      const data = response.body;
      const favouritedItems = yield select(
        state => state.favourites?.favouritedItems
      );
      let isExist = favouritedItems?.find(
        item => item.lineOfBusinessItemId === data?.lineOfBusinessItemId
      );
      if (isExist) {
        //update the record and put the favouriteId
        yield put(actionCreators.itemFavouritedSuccess(data));
      } else {
        //remove the record to API
        yield put(actionCreators.itemUnFavourited(data?.favouritedItemId));
      }
    } else {
      // set error to toast message and remove the record from global state
      yield put(actionCreators.removeFavouriteItems(lineOfBusinessItemId));
      yield put(
        actionCreators.itemFavouritedError({
          code: response?.status,
          message: response?.body,
        })
      );
    }
  } catch (error) {
    yield put(actionCreators.removeFavouriteItems(lineOfBusinessItemId));
    yield put(
      actionCreators.itemFavouritedError({
        code: response?.status,
        message: response?.body,
      })
    );
  }
}

export function* fetchAllFavourited({ payload }) {
  const { userId, accessToken, refreshToken } = payload;
  const headers = yield getFavouriteHeader(accessToken, refreshToken);
  yield genericApiSaga({
    completed: actionCreators.getItemFavouritedSuccess,
    failed: actionCreators.getItemFavouritedError,
    gatewayCall: () =>
      get(
        `/v1/users/${userId}/favouritedItems?lineOfBusiness=${HOTELS_LOB_FAVOURITES}`,
        {
          baseUrl: config.REACT_APP_STATIC_FAVOURITE_BASE_URL,
          headers: {
            ...headers,
          },
        }
      ),
  });
}

export function* fetchByIdFavourited({ payload }) {
  const { userId, favouritedItemId, accessToken, refreshToken } = payload;
  const headers = yield getFavouriteHeader(accessToken, refreshToken);
  yield genericApiSaga({
    completed: actionCreators.getByIdItemFavouritedSuccess,
    failed: actionCreators.getByIdItemFavouritedError,
    gatewayCall: () =>
      get(`/v1/users/${userId}/favouritedItems/${favouritedItemId}`, {
        baseUrl: config.REACT_APP_STATIC_FAVOURITE_BASE_URL,
        headers: {
          ...headers,
        },
      }),
  });
}

export function* itemUnFavourited({ payload }) {
  const {
    userId,
    favouritedItemId,
    accessToken,
    lineOfBusinessItemId,
    data,
    refreshToken,
  } = payload;
  const headers = yield getFavouriteHeader(accessToken, refreshToken);
  let params = {
    lineOfBusiness: HOTELS_LOB_FAVOURITES,
    lineOfBusinessItemId,
    data: { ...data },
    webLink: '',
    mobileLink: '',
    favouritedItemId,
  };
  let response;
  try {
    if (favouritedItemId && favouritedItemId !== undefined) {
      response = yield call(
        remove,
        `/v1/users/${userId}/favouritedItems/${favouritedItemId}`,
        {
          baseUrl: config.REACT_APP_STATIC_FAVOURITE_BASE_URL,
          headers: {
            ...headers,
          },
        }
      );
    }

    if (response.status === 204 || response.status === 200) {
      // success
      yield put(actionCreators.itemUnFavouritedSuccess(true));
    } else {
      // Error on remove > add the prev record on global state
      yield put(actionCreators.addFavouriteItem(params));
      yield put(
        actionCreators.itemUnFavouritedError({
          code: response?.status,
          message: response?.body,
        })
      );
    }
  } catch (error) {
    yield put(actionCreators.addFavouriteItem(params));
    yield put(
      actionCreators.itemUnFavouritedError({
        code: response?.status,
        message: response?.body,
      })
    );
  }
}

export function* recordItemFavourited({ payload }) {
  const {
    userId,
    favouritedItemId,
    action,
    accessToken,
    refreshToken,
  } = payload;
  const headers = yield getFavouriteHeader(accessToken, refreshToken);
  yield genericApiSaga({
    completed: actionCreators.getRecordItemFavouritedSuccess,
    failed: actionCreators.getRecordItemFavouritedError,
    gatewayCall: () =>
      remove(`/v1/users/${userId}/favouritedItems/${favouritedItemId}/events`, {
        baseUrl: config.REACT_APP_STATIC_FAVOURITE_BASE_URL,
        headers: {
          ...headers,
        },
        params: {
          action,
        },
      }),
  });
}
export default function* createFavouritesSaga() {
  yield takeEvery(types.FAVOURITED_ITEM, itemFavourited);
  yield takeLatest(types.GET_FAVOURITED_ITEM, fetchAllFavourited);
  yield takeLatest(types.GET_BY_FAVOURITED_ITEM, fetchByIdFavourited);
  yield takeEvery(types.UNFAVOURITED_ITEM, itemUnFavourited);
  yield takeLatest(types.RECORD_FAVOURITED_ITEM, recordItemFavourited);
}
